import { FaComments } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./FemaleLevelPage.css";

export default function FemaleLevelActions() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div
      className="femaleChatPriceCard"
      onClick={() => navigate("/fe/chat-price")}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          navigate("/fe/chat-price");
        }
      }}
    >
      <div className="chatPriceLeft">
        <div className="chatPriceIcon">
          <FaComments />
        </div>

        <div className="chatPriceText">
          <h4>
            {t("female_level.actions.callLevelTitle", {
              defaultValue: "مستوى المكالمة",
            })}
          </h4>
          <p>
            {t("female_level.actions.callLevelSubtitle", {
              defaultValue: "اضغطي لاختيار مستوى مكالمتك وتخفيض السعر إذا رغبتِ",
            })}
          </p>
        </div>
      </div>

      <button
        className="chatPriceBtn"
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          navigate("/fe/chat-price");
        }}
      >
        {t("female_level.actions.editCallLevel", {
          defaultValue: "تغيير",
        })}
      </button>
    </div>
  );
}